let lPrefetchDisparado = false

export const prefetchTicketPainel = () => {
  if (lPrefetchDisparado) return
  lPrefetchDisparado = true
  import(/* webpackPrefetch: true */ "../components/Ticket")
}
